import { createContext, useContext } from "react";
import { useMatches } from "react-router-dom";

import {
  MY_SPACE_SETTINGS_NAV,
  WORKSPACE_SETTINGS_NAV,
  type ISettingsNav,
} from "@/config/settings-nav.config";

/**
 * Route `handle` flag marking a branch as main Settings. The app `Layout`
 * reads it to swap its main menu for the settings sidebar — set it on the
 * settings route's root, and on any form route nested under its path but
 * declared elsewhere (the company-policy forms).
 */
export interface ISettingsRouteHandle {
  settingsSpace?: ISettingsNav["space"];
}

/** The settings nav for the current route, or `undefined` off Settings. */
export const useSettingsRouteNav = (): ISettingsNav | undefined => {
  const matches = useMatches();
  const space = matches
    .map((m) => (m.handle as ISettingsRouteHandle | undefined)?.settingsSpace)
    .find(Boolean);
  if (space === "company") return WORKSPACE_SETTINGS_NAV;
  if (space === "myspace") return MY_SPACE_SETTINGS_NAV;
  return undefined;
};

/**
 * Lets the settings page open the sidebar overlay below `lg`. Its open state
 * is the app `Layout`'s own sidebar state — the one the top bar's menu button
 * toggles — so both openers drive the same overlay.
 */
export const SettingsShellContext = createContext<{ openNav: () => void }>({
  openNav: () => {},
});

export const useSettingsShell = () => useContext(SettingsShellContext);
